import Box from "@mui/joy/Box";

const Settings = ()  => {
  return (
    <Box>
      Settings
    </Box>
  );
}


export default Settings;